__turbopack_context__.v({
  "rawTable": "LkNUPG_rawTable",
  "table": "LkNUPG_table",
  "tableTbody___9Sp9T": "LkNUPG_tableTbody___9Sp9T",
  "tableTd__oboo2": "LkNUPG_tableTd__oboo2",
  "tableTd__ozvr7": "LkNUPG_tableTd__ozvr7",
  "tableTd__tk22X": "LkNUPG_tableTd__tk22X",
  "tableTd__yJsY": "LkNUPG_tableTd__yJsY",
  "tableTh___9I6A5": "LkNUPG_tableTh___9I6A5",
  "tableTh__egg6U": "LkNUPG_tableTh__egg6U",
  "tableTh__pYjac": "LkNUPG_tableTh__pYjac",
  "tableTh__srbkf": "LkNUPG_tableTh__srbkf",
  "tableThead__vyONq": "LkNUPG_tableThead__vyONq",
  "tableTr___08JVq": "LkNUPG_tableTr___08JVq",
  "tableTr__dkcak": "LkNUPG_tableTr__dkcak",
  "text___4SCh": "LkNUPG_text___4SCh",
  "text___6S7DM": "LkNUPG_text___6S7DM",
  "text__buZjd": "LkNUPG_text__buZjd",
  "text__pf5Fg": "LkNUPG_text__pf5Fg",
});
